var map = {
	"./bumen1.png": "7d96",
	"./bumen2.png": "2a42",
	"./daijian.png": "0638",
	"./jianli.png": "4a24",
	"./jianshe.png": "8f5f",
	"./kancha.png": "2160",
	"./leaf.png": "b375",
	"./sheji.png": "4564",
	"./shigong.png": "276e",
	"./zhuanye.png": "b7cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a6b";